var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobileLdir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 46,
    viewBox: "0 0 86 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6899 32.8442H63.2383L70.0429 45.7277H71.4946L64.6899 32.8442Z",
    fill: "#00AADB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7881 32.8442H59.3364L66.2318 45.7277H67.5928L60.7881 32.8442Z",
    fill: "#00AADB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.436 32.8442L62.3314 45.7277H63.6924L56.8877 32.8442H55.436Z",
    fill: "#00AADB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5337 32.8442L58.4291 45.7277H59.8808L52.9854 32.8442H51.5337Z",
    fill: "#00AADB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6333 32.8442L54.5287 45.7277H55.9804L49.085 32.8442H47.6333Z",
    fill: "#00AADB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8677 45.7274L45.183 0H43.7314L19.416 45.7274H20.8677Z",
    fill: "#4E3629"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9658 45.7274L41.2812 0H39.9202L15.5142 45.7274H16.9658Z",
    fill: "#4E3629"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0654 45.7274L37.4715 0H36.0198L11.6138 45.7274H13.0654Z",
    fill: "#4E3629"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16318 45.7274L33.5693 0H32.1176L7.80225 45.7274H9.16318Z",
    fill: "#4E3629"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35254 45.7274L29.6679 0H28.2162L3.90088 45.7274H5.35254Z",
    fill: "#4E3629"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45545 45.5846L25.8342 0.0517578C24.8336 0.232444 23.9239 0.864844 23.4691 1.85862L0 45.5846H1.45545Z",
    fill: "#4E3629"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3374 32.9897H43.918L49.6845 43.8101C50.2168 44.7857 51.0153 45.4065 51.9912 45.5839L45.3374 32.9897Z",
    fill: "#00AADB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1208 22.9771L72.6592 44.2418L73.3869 45.582L85.5763 22.9771H84.1208Z",
    fill: "#00AFD7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2373 22.9771L70.7217 40.9818L71.4537 42.3527L81.7012 22.9771H80.2373Z",
    fill: "#00AFD7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3638 22.9771L68.7832 37.1258L69.5139 38.4776L77.8252 22.9771H76.3638Z",
    fill: "#00AFD7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5666 22.9771L66.8462 33.2814L67.5843 34.6025L73.9506 22.9771H72.5666Z",
    fill: "#00AFD7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8575 22.9771L64.9087 29.7195L65.6792 31.0502L70.3985 22.9771H68.8575Z",
    fill: "#00AFD7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8722 22.9771L63.2944 25.9404L63.9587 27.1751L66.2008 22.9771H64.8722Z",
    fill: "#00AFD7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1159 31.0499L39.4783 14.5806L38.751 15.953L46.7521 31.0499H48.1159Z",
    fill: "#4E3629"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9914 31.0494L41.4123 11.0278L40.689 12.3019L50.5447 31.0494H51.9914Z",
    fill: "#4E3629"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8665 31.0498L43.2613 7.47607L42.6265 8.83089L54.4155 31.0498H55.8665Z",
    fill: "#4E3629"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6162 31.0536L47.2216 0.375488L46.501 1.72497L62.1749 31.0536H63.6162Z",
    fill: "#4E3629"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7411 31.0529L45.2862 3.604L44.5635 4.97189L58.2956 31.0529H59.7411Z",
    fill: "#4E3629"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9176 31.0512L37.2149 18.457L36.4902 19.8064L42.5589 31.0512H43.9176Z",
    fill: "#4E3629"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0557 32.5723L70.0418 45.728H71.4935L64.5073 32.5723H63.0557Z",
    fill: "#00AFD7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1558 32.5723L66.2326 45.728H67.5936L60.6074 32.5723H59.1558Z",
    fill: "#00AFD7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2549 32.5723L62.3317 45.728H63.7834L56.7065 32.5723H55.2549Z",
    fill: "#00AFD7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4424 32.5723L58.4285 45.728H59.8802L52.8033 32.5723H51.4424Z",
    fill: "#00AFD7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.542 32.5723L54.5281 45.728H55.9798L48.9937 32.5723H47.542Z",
    fill: "#00AFD7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6411 32.5723L49.6292 43.9134C50.1736 44.9114 50.9902 45.5465 51.9882 45.728L45.002 32.5723H43.6411Z",
    fill: "#00AFD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobileLdir);
export default __webpack_public_path__ + "static/media/logo-mobile-ldir.5edb783f8752f5aec619a5351d2b81b2.svg";
export { ForwardRef as ReactComponent };